/*
 * Kuehn Doggear Theme: scroll-gekoppelte Sequenz (sections/start-sequenz.liquid).
 * Vorbild: components/sequenz.tsx (motion: useScroll -> useTransform).
 *
 * Die Bewegung ist AN den Scroll gebunden, nicht nur von ihm ausgeloest:
 * - Fortschritt p der Spur: 0, wenn ihre Oberkante an der Oberkante des
 *   Fensters liegt ("start start"), 1, wenn ihre Unterkante die Unterkante des
 *   Fensters erreicht ("end end"). Dazwischen linear, ausserhalb begrenzt.
 * - Zoom aller Bildebenen 1 -> 1,08 und Fortschrittslinie 0,04 -> 1, beides
 *   stufenlos ueber die ganze Spur, nicht in Stufen.
 * - aktive Station = floor(p * Anzahl). Ihr Bild blendet in 0,45 s ueber
 *   (cubic-bezier(0.32, 0.72, 0, 1)), die Texte der anderen treten zurueck
 *   (CSS-Uebergang ueber data-aktiv, 0,5 s).
 *
 * Das Layout (klebende Buehne oder gestapelte Stationen) entscheidet allein
 * das CSS ueber die Variante "bewegt:" (theme-build/teile/interaktiv.css).
 * Bei prefers-reduced-motion tut dieses Skript nichts und raeumt hinter sich
 * auf; ohne JavaScript stehen die Stationen ohnehin untereinander.
 *
 * Theme-Editor: Abschnitte werden bei shopify:section:load/unload neu
 * aufgebaut bzw. abgeraeumt; ein angewaehlter Stations-Block zeigt sein Bild.
 *
 * Leistung: gerechnet wird nur, solange die Spur im Blick ist oder kurz davor
 * steht (IntersectionObserver mit einem halben Fenster Vorlauf), hoechstens
 * einmal je Bild (requestAnimationFrame), erst lesen, dann schreiben, und
 * geschrieben werden nur transform und opacity.
 */
(function () {
  'use strict';

  /* Im Theme-Editor kann die Datei erneut ausgefuehrt werden: dann nur neu einsammeln. */
  if (window.KuehnSequenz) {
    window.KuehnSequenz.starten();
    return;
  }

  var ZOOM = 0.08; // der Zoom laeuft von 1 bis 1,08
  var LINIE_ANFANG = 0.04; // die Fortschrittslinie von 0,04 bis 1
  var BLENDE = { duration: 450, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' };
  var PASSIV = { passive: true };
  /* Ein halbes Fenster Vorlauf: der Stand stimmt, bevor die Spur zu sehen ist. */
  var VORLAUF = { rootMargin: '50% 0px' };

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instanzen = [];

  function liste(wurzel, auswahl) {
    return Array.prototype.slice.call(wurzel.querySelectorAll(auswahl));
  }

  function merkmal(element, name, an) {
    if (an) element.setAttribute(name, '');
    else element.removeAttribute(name);
  }

  function erzeugen(spur) {
    var ebenen = liste(spur, '[data-sequenz-ebene]');
    var texte = liste(spur, '[data-sequenz-text]');
    var linie = spur.querySelector('[data-sequenz-linie]');
    var bilder = ebenen.map(function (ebene) {
      return ebene.querySelector('img');
    });
    var alts = bilder.map(function (bild) {
      return bild ? bild.getAttribute('alt') || '' : '';
    });
    var blenden = []; // laufende Ueberblendung je Ebene
    var anzahl = texte.length;
    var aktiv = 0; // so gibt Liquid das Markup aus: die erste Station ist aktiv
    var stand = -1; // zuletzt gezeichneter Fortschritt
    var gewaehlt = -1; // im Theme-Editor angewaehlte Station, sonst -1
    var laeuft = false;
    var horcht = false;
    var bildId = 0;
    var beobachter = null;

    /*
     * Augenblickliche Deckkraft der Ebenen, deren Zustand gleich wechselt
     * (sonst null). Gelesen wird, bevor in diesem Bild irgendetwas geschrieben ist.
     */
    function deckkraefte(neu) {
      return ebenen.map(function (ebene, i) {
        if (!ebene.animate || ebene.hasAttribute('data-aktiv') === (i === neu)) return null;
        return parseFloat(window.getComputedStyle(ebene).opacity);
      });
    }

    /*
     * Ueberblendung einer Ebene. Der Ruhezustand haengt an data-aktiv
     * (Klassen opacity-0 / data-[aktiv]:opacity-100); die Blende selbst laeuft
     * als Web Animation vom AUGENBLICKLICHEN Wert ("von") zum Ziel und immer
     * ueber die volle Dauer. So verhaelt sich auch das Original, wenn man mitten
     * in einer Blende die Richtung wechselt (ein CSS-Uebergang wuerde die Umkehr
     * kuerzen). Ohne "von" gilt der neue Zustand sofort.
     */
    function ueberblenden(i, an, von, sofort) {
      var ebene = ebenen[i];
      // Nur das sichtbare Bild traegt seinen Alt-Text.
      if (bilder[i]) bilder[i].alt = an ? alts[i] : '';
      // Unveraendert: eine laufende Blende bleibt ungestoert.
      if (ebene.hasAttribute('data-aktiv') === an && !sofort) return;
      if (blenden[i]) {
        blenden[i].cancel();
        blenden[i] = null;
      }
      merkmal(ebene, 'data-aktiv', an);
      var ziel = an ? 1 : 0;
      if (von === null || isNaN(von) || von === ziel) return;
      var lauf = ebene.animate([{ opacity: von }, { opacity: ziel }], BLENDE);
      lauf.onfinish = function () {
        if (blenden[i] === lauf) blenden[i] = null;
      };
      blenden[i] = lauf;
    }

    /* "von": Deckkraefte aus deckkraefte(); ohne sie wechselt die Station sofort, ohne Blende. */
    function wechseln(neu, von) {
      for (var i = 0; i < anzahl; i++) {
        merkmal(texte[i], 'data-aktiv', i === neu);
        if (ebenen[i]) ueberblenden(i, i === neu, von ? von[i] : null, !von);
      }
      aktiv = neu;
    }

    function zeichnen(sofort) {
      // lesen
      var flaeche = spur.getBoundingClientRect();
      var strecke = flaeche.height - document.documentElement.clientHeight;
      var p = strecke > 0 ? Math.min(1, Math.max(0, -flaeche.top / strecke)) : 0;
      if (p === stand && !sofort) return;
      stand = p;
      var neu = Math.max(0, Math.min(anzahl - 1, Math.floor(p * anzahl)));
      if (gewaehlt > -1) neu = gewaehlt;
      var wechsel = sofort || neu !== aktiv;
      var von = wechsel && !sofort ? deckkraefte(neu) : null;
      // schreiben
      var zoom = 'scale(' + (1 + ZOOM * p) + ')';
      for (var i = 0; i < ebenen.length; i++) ebenen[i].style.transform = zoom;
      if (linie) linie.style.transform = 'scaleY(' + (LINIE_ANFANG + (1 - LINIE_ANFANG) * p) + ')';
      if (wechsel) wechseln(neu, von);
    }

    /*
     * Theme-Editor: solange dort ein Stations-Block angewaehlt ist, zeigt die
     * Buehne dessen Bild, egal wo die Seite gerade steht. Danach gilt wieder
     * der Scrollfortschritt.
     */
    function waehlen(block) {
      gewaehlt = -1;
      for (var i = 0; block && i < anzahl; i++) {
        if (block.contains(texte[i])) gewaehlt = i;
      }
      if (!laeuft) return;
      stand = -1;
      zeichnen(false);
    }

    function planen() {
      if (bildId || !laeuft) return;
      bildId = window.requestAnimationFrame(function () {
        bildId = 0;
        zeichnen(false);
      });
    }

    function horchen(ein) {
      if (ein === horcht) return;
      horcht = ein;
      var methode = ein ? 'addEventListener' : 'removeEventListener';
      window[methode]('scroll', planen, PASSIV);
      window[methode]('resize', planen, PASSIV);
    }

    function an() {
      if (laeuft || wenigBewegung.matches || !anzahl) return;
      laeuft = true;
      // Erster Stand ohne Blende: wer mitten in der Sequenz landet, sieht sofort das richtige Bild.
      zeichnen(true);
      if ('IntersectionObserver' in window) {
        beobachter = new IntersectionObserver(function (eintraege) {
          var nah = eintraege[eintraege.length - 1].isIntersecting;
          horchen(nah);
          // Kommt die Spur in Reichweite (auch nach einem Sprung ueber sie hinweg), gilt der
          // Stand sofort und ohne Blende; beim Verlassen steht der Fortschritt fest auf 0 oder 1.
          if (nah) zeichnen(true);
          else planen();
        }, VORLAUF);
        beobachter.observe(spur);
      } else {
        horchen(true);
      }
    }

    /* Alles zurueck auf den Stand, den Liquid ausgegeben hat. */
    function aus() {
      if (!laeuft) return;
      laeuft = false;
      if (beobachter) {
        beobachter.disconnect();
        beobachter = null;
      }
      horchen(false);
      if (bildId) {
        window.cancelAnimationFrame(bildId);
        bildId = 0;
      }
      for (var i = 0; i < anzahl; i++) {
        merkmal(texte[i], 'data-aktiv', i === 0);
        if (!ebenen[i]) continue;
        if (blenden[i]) {
          blenden[i].cancel();
          blenden[i] = null;
        }
        merkmal(ebenen[i], 'data-aktiv', i === 0);
        ebenen[i].style.transform = '';
        if (bilder[i]) bilder[i].alt = alts[i];
      }
      if (linie) linie.style.transform = '';
      aktiv = 0;
      stand = -1;
      gewaehlt = -1;
    }

    return { wurzel: spur, an: an, aus: aus, waehlen: waehlen };
  }

  /* Sammelt alle Sequenzen im Bereich ein (ohne Angabe: im ganzen Dokument). */
  function starten(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (document.documentElement.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
    liste(bereich && bereich.querySelectorAll ? bereich : document, '[data-sequenz]').forEach(function (spur) {
      for (var i = 0; i < instanzen.length; i++) {
        if (instanzen[i].wurzel === spur) return;
      }
      var instanz = erzeugen(spur);
      instanzen.push(instanz);
      instanz.an();
    });
  }

  function beenden(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (bereich && !bereich.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
  }

  /* Wechselt die Einstellung zur Laufzeit, schaltet das CSS den Zweig um; das Skript zieht nach. */
  function bewegungGeaendert() {
    instanzen.forEach(function (instanz) {
      if (wenigBewegung.matches) instanz.aus();
      else instanz.an();
    });
  }
  if (wenigBewegung.addEventListener) wenigBewegung.addEventListener('change', bewegungGeaendert);
  else if (wenigBewegung.addListener) wenigBewegung.addListener(bewegungGeaendert);

  /* Theme-Editor: Abschnitt neu aufbauen bzw. hinter ihm aufraeumen */
  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    beenden(e.target);
  });
  /* Theme-Editor: der angewaehlte Block muss zu sehen sein, also auch sein Bild */
  function blockGewaehlt(block, an) {
    instanzen.forEach(function (instanz) {
      if (instanz.wurzel.contains(block)) instanz.waehlen(an ? block : null);
    });
  }
  document.addEventListener('shopify:block:select', function (e) {
    blockGewaehlt(e.target, true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    blockGewaehlt(e.target, false);
  });

  window.KuehnSequenz = { starten: starten, beenden: beenden };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      starten();
    });
  } else {
    starten();
  }
})();
